import React, { useEffect } from 'react';
import { Button } from 'antd';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [showContactModal, setShowContactModal] = React.useState(false);

  // 添加平滑滚动
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const stagger = {
    animate: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <div style={{ 
      width: '100%',
      minHeight: '100vh'
    }}>
      {/* 顶部导航栏 */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '60px',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          color: '#333', 
          fontSize: window.innerWidth <= 768 ? '16px' : '20px', 
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }}>
          {window.innerWidth <= 480 ? '🔮 慧卜' : '🔮 慧卜'}
        </div>
        <div style={{ display: 'flex', gap: window.innerWidth <= 480 ? '8px' : '16px' }}>
          <Button 
            type="link" 
            style={{ 
              color: '#666',
              padding: window.innerWidth <= 480 ? '4px 8px' : undefined
            }}
            size={window.innerWidth <= 480 ? 'small' : 'middle'}
            onClick={() => navigate('/login')}
          >
            登录
          </Button>
          <Button 
            type="primary"
            size={window.innerWidth <= 480 ? 'small' : 'middle'}
            onClick={() => navigate('/register')}
          >
            {window.innerWidth <= 480 ? '注册' : '注册试用'}
          </Button>
        </div>
      </div>

      {/* Section 1: 英雄页面 */}
      <section style={{
        background: 'linear-gradient(135deg, #FFE0B2 0%, #FFCC80 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333',
        textAlign: 'center',
        position: 'relative',
        padding: '80px 20px 40px'
      }}>
        <motion.div
          initial="initial"
          animate="animate"
          variants={stagger}
          style={{ 
            maxWidth: '800px', 
            padding: '0 20px',
            textAlign: 'center' 
          }}
        >
          <motion.h1 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '2.2rem' : window.innerWidth <= 768 ? '2.8rem' : '3.5rem', 
              marginBottom: '24px',
              fontWeight: 'bold',
              lineHeight: '1.2',
              color: '#333'
            }}
          >
            🔮 让塔罗解读更高效
          </motion.h1>
          <motion.h2 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '1.1rem' : window.innerWidth <= 768 ? '1.3rem' : '1.5rem', 
              marginBottom: '40px',
              opacity: 0.8,
              fontWeight: 'normal',
              lineHeight: '1.4',
              color: '#555'
            }}
          >
            你的AI塔罗助理
          </motion.h2>
          <motion.div 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '0.95rem' : '1.1rem', 
              marginBottom: '50px', 
              lineHeight: '1.6',
              color: '#666'
            }}
          >
            <p>✨ 智能提效 · 助力增收</p>
            <p>🎨 海量模板 · 随心选用</p>
            <p>📷 精美图文 · 一键生成</p>
            <p>🤖 智能解读 · 专业洞察</p>
            <p>📈 订单客户 · 便捷管理</p>
            <p>🤝 团队协作 · 云端同步</p>
          </motion.div>
          <motion.div 
            variants={fadeInUp}
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= 480 ? 'column' : 'row',
              gap: window.innerWidth <= 480 ? '15px' : '20px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Button 
              size={window.innerWidth <= 480 ? 'middle' : 'large'}
              type="primary"
              style={{ 
                height: window.innerWidth <= 480 ? '45px' : '50px', 
                fontSize: window.innerWidth <= 480 ? '16px' : '18px', 
                padding: window.innerWidth <= 480 ? '0 30px' : '0 40px',
                minWidth: window.innerWidth <= 480 ? '200px' : 'auto',
                background: 'linear-gradient(45deg, #FF8A65, #FF7043)',
                border: 'none'
              }}
              onClick={() => navigate('/register')}
            >
              {window.innerWidth <= 480 ? '免费试用' : '免费试用'}
            </Button>
            {/*
            <Button
              size={window.innerWidth <= 480 ? 'middle' : 'large'}
              style={{
                height: window.innerWidth <= 480 ? '45px' : '50px',
                fontSize: window.innerWidth <= 480 ? '16px' : '18px',
                padding: window.innerWidth <= 480 ? '0 30px' : '0 40px',
                borderColor: '#FF8A65',
                color: '#FF7043',
                minWidth: window.innerWidth <= 480 ? '200px' : 'auto',
                background: 'transparent'
              }}
              onClick={() => setShowContactModal(true)}
            >
              联系我们
            </Button>
            */}
          </motion.div>
        </motion.div>
      </section>

      {/* Section 2: 轻松上手 */}
      <section style={{
        background: 'linear-gradient(135deg, #FFCDD2 0%, #F8BBD9 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333',
        padding: window.innerWidth <= 768 ? '70px 15px 40px' : '100px 40px 60px'
      }}>
        <motion.div
          initial="initial"
          animate="animate" 
          variants={stagger}
          style={{ 
            maxWidth: '1200px', 
            width: '100%',
            padding: '0 20px'
          }}
        >
          <motion.h2 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '1.8rem' : window.innerWidth <= 768 ? '2.2rem' : '2.5rem', 
              textAlign: 'center', 
              marginBottom: window.innerWidth <= 768 ? '30px' : '60px',
              fontWeight: 'bold',
              lineHeight: '1.2',
              color: '#333'
            }}
          >
            ✨ 轻松上手
          </motion.h2>
          
          {/* 第一组: 客户管理界面 */}
          <motion.div 
            variants={fadeInUp}
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
              alignItems: 'center',
              gap: window.innerWidth <= 768 ? '30px' : '50px',
              marginBottom: window.innerWidth <= 768 ? '40px' : '80px'
            }}
          >
            {/* 图片容器 */}
            <div style={{
              flex: '1',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative'
            }}>
              <div style={{
                position: 'relative',
                borderRadius: '20px',
                padding: '8px',
                background: 'linear-gradient(45deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1), 0 8px 16px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.8)'
              }}>
                <img 
                  src="/pic_1.png" 
                  alt="客户管理界面"
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    height: 'auto',
                    borderRadius: '15px',
                    display: 'block'
                  }}
                />
                {/* 渐变边缘效果 */}
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  right: '8px',
                  bottom: '8px',
                  borderRadius: '15px',
                  background: `linear-gradient(135deg, 
                    rgba(255,205,210,0.3) 0%, 
                    rgba(248,187,217,0.3) 50%, 
                    transparent 70%)`,
                  pointerEvents: 'none'
                }}></div>
              </div>
            </div>

            {/* 文字内容 */}
            <div style={{
              flex: '1',
              textAlign: window.innerWidth <= 768 ? 'center' : 'left'
            }}>
              <h3 style={{
                fontSize: window.innerWidth <= 480 ? '1.3rem' : '1.5rem',
                fontWeight: 'bold',
                color: '#333',
                marginBottom: '20px',
                lineHeight: '1.3'
              }}>
                📊 订单全流程化管理，客户进度一目了然
              </h3>
              <p style={{
                fontSize: window.innerWidth <= 480 ? '1rem' : '1.1rem',
                color: '#555',
                lineHeight: '1.6',
                marginBottom: '0'
              }}>
                ✨ 每一次的洞察建议，都值得被精美呈现
              </p>
            </div>
          </motion.div>

          {/* 第二组: 模板选择界面 */}
          <motion.div 
            variants={fadeInUp}
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= 768 ? 'column' : 'row-reverse',
              alignItems: 'center',
              gap: window.innerWidth <= 768 ? '30px' : '50px'
            }}
          >
            {/* 图片容器 */}
            <div style={{
              flex: '1',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative'
            }}>
              <div style={{
                position: 'relative',
                borderRadius: '20px',
                padding: '8px',
                background: 'linear-gradient(45deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1), 0 8px 16px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.8)'
              }}>
                <img 
                  src="/pic_2.png" 
                  alt="模板选择界面"
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    height: 'auto',
                    borderRadius: '15px',
                    display: 'block'
                  }}
                />
                {/* 渐变边缘效果 */}
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  right: '8px',
                  bottom: '8px',
                  borderRadius: '15px',
                  background: `linear-gradient(135deg, 
                    rgba(255,205,210,0.3) 0%, 
                    rgba(248,187,217,0.3) 50%, 
                    transparent 70%)`,
                  pointerEvents: 'none'
                }}></div>
              </div>
            </div>

            {/* 文字内容 */}
            <div style={{
              flex: '1',
              textAlign: window.innerWidth <= 768 ? 'center' : 'left'
            }}>
              <h3 style={{
                fontSize: window.innerWidth <= 480 ? '1.3rem' : '1.5rem',
                fontWeight: 'bold',
                color: '#333',
                marginBottom: '20px',
                lineHeight: '1.3'
              }}>
                🎨 内置海量专业牌阵，轻松应对各类咨询
              </h3>
              <p style={{
                fontSize: window.innerWidth <= 480 ? '1rem' : '1.1rem',
                color: '#555',
                lineHeight: '1.6',
                marginBottom: '0'
              }}>
                📝 跟随指引轻松记录，咨询重点滴水不漏
              </p>
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* Section 3: 效率对比 */}
      <section style={{
        background: 'linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333',
        padding: window.innerWidth <= 768 ? '70px 15px 40px' : '100px 40px 60px'
      }}>
        <motion.div
          initial="initial"
          animate="animate"
          variants={stagger}
          style={{ 
            maxWidth: '1000px', 
            width: '100%', 
            textAlign: 'center',
            padding: '0 20px'
          }}
        >
          <motion.h2 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '1.8rem' : window.innerWidth <= 768 ? '2.2rem' : '2.5rem', 
              marginBottom: window.innerWidth <= 768 ? '30px' : '40px',
              fontWeight: 'bold',
              lineHeight: '1.2',
              color: '#333'
            }}
          >
            💰 效率提升助力收入增长
          </motion.h2>
          
          <motion.div 
            variants={fadeInUp}
            style={{
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              borderRadius: '20px',
              padding: window.innerWidth <= 480 ? '25px' : '40px',
              marginBottom: '40px',
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}
          >
            {window.innerWidth <= 480 ? (
              <div style={{ textAlign: 'left' }}>
                <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255,152,101,0.1)', borderRadius: '10px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#333' }}>客户信息管理</div>
                  <div style={{ marginBottom: '5px', color: '#666' }}>传统方式: 5分钟</div>
                  <div style={{ color: '#FF8A65', fontWeight: 'bold' }}>使用系统: 1分钟</div>
                </div>
                <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255,152,101,0.1)', borderRadius: '10px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#333' }}>牌阵解读分析</div>
                  <div style={{ marginBottom: '5px', color: '#666' }}>传统方式: 25分钟</div>
                  <div style={{ color: '#FF8A65', fontWeight: 'bold' }}>使用系统: 3分钟</div>
                </div>
                <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255,152,101,0.1)', borderRadius: '10px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#333' }}>报告制作</div>
                  <div style={{ marginBottom: '5px', color: '#666' }}>传统方式: 10分钟</div>
                  <div style={{ color: '#FF8A65', fontWeight: 'bold' }}>使用系统: 自动生成</div>
                </div>
                <div style={{ padding: '20px', background: 'rgba(255,152,101,0.2)', borderRadius: '10px', textAlign: 'center' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#333' }}>总计对比</div>
                  <div style={{ marginBottom: '5px', color: '#666' }}>传统方式: <strong>40分钟/单</strong></div>
                  <div style={{ color: '#FF8A65', fontSize: '1.2rem', fontWeight: 'bold' }}>使用系统: 4分钟/单</div>
                </div>
              </div>
            ) : (
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: '1fr 1fr 1fr', 
                gap: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontWeight: 'bold', color: '#333' }}>工作环节</div>
                <div style={{ fontWeight: 'bold', color: '#333' }}>传统方式</div>
                <div style={{ fontWeight: 'bold', color: '#333' }}>使用系统</div>
                
                <div style={{ color: '#666' }}>客户信息管理</div>
                <div style={{ color: '#666' }}>5分钟</div>
                <div style={{ color: '#FF8A65' }}><strong>1分钟</strong></div>
                
                <div style={{ color: '#666' }}>牌阵解读分析</div>
                <div style={{ color: '#666' }}>25分钟</div>
                <div style={{ color: '#FF8A65' }}><strong>3分钟</strong></div>
                
                <div style={{ color: '#666' }}>报告制作</div>
                <div style={{ color: '#666' }}>10分钟</div>
                <div style={{ color: '#FF8A65' }}><strong>自动生成</strong></div>
                
                <div style={{ fontWeight: 'bold', color: '#333' }}>总计</div>
                <div style={{ fontWeight: 'bold', color: '#666' }}>40分钟/单</div>
                <div style={{ color: '#FF8A65', fontSize: '1.2rem', fontWeight: 'bold' }}>4分钟/单</div>
              </div>
            )}
          </motion.div>

          <motion.div variants={fadeInUp}>
            <Button 
              size="large" 
              type="primary"
              style={{ 
                height: '50px', 
                fontSize: '18px', 
                padding: '0 30px',
                background: 'linear-gradient(45deg, #FF8A65, #FF7043)',
                borderColor: 'transparent'
              }}
              onClick={() => navigate('/register')}
            >
              立即体验效率提升
            </Button>
          </motion.div>
        </motion.div>
      </section>

      {/* Section 4: 开始使用 */}
      <section style={{
        background: 'linear-gradient(135deg, #FFFDE7 0%, #FFF8E1 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#333',
        padding: window.innerWidth <= 768 ? '70px 15px 40px' : '100px 40px 60px'
      }}>
        <motion.div
          initial="initial"
          animate="animate"
          variants={stagger}
          style={{ 
            maxWidth: '800px', 
            width: '100%', 
            textAlign: 'center',
            padding: '0 20px'
          }}
        >
          <motion.h2 
            variants={fadeInUp}
            style={{ 
              fontSize: window.innerWidth <= 480 ? '1.8rem' : window.innerWidth <= 768 ? '2.2rem' : '2.5rem', 
              marginBottom: window.innerWidth <= 480 ? '25px' : '30px',
              fontWeight: 'bold',
              color: '#333',
              lineHeight: '1.2'
            }}
          >
            🎁 立即开始您的数字化转型
          </motion.h2>
          
          <motion.div 
            variants={fadeInUp}
            style={{
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: window.innerWidth <= 480 ? '15px' : '20px',
              padding: window.innerWidth <= 480 ? '25px' : '40px',
              marginBottom: window.innerWidth <= 480 ? '30px' : '40px',
              boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
            }}
          >
            <h3 style={{ 
              fontSize: window.innerWidth <= 480 ? '1.3rem' : '1.5rem', 
              marginBottom: window.innerWidth <= 480 ? '25px' : '30px', 
              color: '#333',
              fontWeight: 'bold'
            }}>
              🆓 新客户专享优惠
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: window.innerWidth <= 480 ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: window.innerWidth <= 480 ? '15px' : '20px',
              marginBottom: window.innerWidth <= 480 ? '25px' : '30px'
            }}>
              <div style={{ padding: window.innerWidth <= 480 ? '18px' : '20px' }}>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1.8rem' : '2rem', 
                  marginBottom: window.innerWidth <= 480 ? '10px' : '12px' 
                }}>🎯</div>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1rem' : '1.1rem',
                  fontWeight: 'bold',
                  color: '#333',
                  marginBottom: '5px'
                }}>
                  前100张牌完全免费
                </div>
                <div style={{ 
                  color: '#666', 
                  fontSize: window.innerWidth <= 480 ? '0.85rem' : '0.9rem' 
                }}>体验所有功能</div>
              </div>
              <div style={{ padding: window.innerWidth <= 480 ? '18px' : '20px' }}>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1.8rem' : '2rem', 
                  marginBottom: window.innerWidth <= 480 ? '10px' : '12px' 
                }}>📈</div>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1rem' : '1.1rem',
                  fontWeight: 'bold',
                  color: '#333',
                  marginBottom: '5px'
                }}>
                  使用量越大越便宜
                </div>
                <div style={{ 
                  color: '#666', 
                  fontSize: window.innerWidth <= 480 ? '0.85rem' : '0.9rem' 
                }}>阶梯式计费</div>
              </div>
              <div style={{ padding: window.innerWidth <= 480 ? '18px' : '20px' }}>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1.8rem' : '2rem', 
                  marginBottom: window.innerWidth <= 480 ? '10px' : '12px' 
                }}>💰</div>
                <div style={{ 
                  fontSize: window.innerWidth <= 480 ? '1rem' : '1.1rem',
                  fontWeight: 'bold',
                  color: '#333',
                  marginBottom: '5px'
                }}>
                  无月租费
                </div>
                <div style={{ 
                  color: '#666', 
                  fontSize: window.innerWidth <= 480 ? '0.85rem' : '0.9rem' 
                }}>按需付费</div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            variants={fadeInUp}
            style={{
              display: 'flex',
              flexDirection: window.innerWidth <= 480 ? 'column' : 'row',
              gap: window.innerWidth <= 480 ? '15px' : '20px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Button 
              size={window.innerWidth <= 480 ? 'middle' : 'large'}
              type="primary"
              style={{ 
                height: window.innerWidth <= 480 ? '50px' : '60px', 
                fontSize: window.innerWidth <= 480 ? '18px' : '20px', 
                padding: window.innerWidth <= 480 ? '0 40px' : '0 50px',
                background: 'linear-gradient(45deg, #FF8A65, #FF7043)',
                border: 'none',
                borderRadius: '30px',
                minWidth: window.innerWidth <= 480 ? '220px' : 'auto'
              }}
              onClick={() => navigate('/register')}
            >
              🚀 立即注册试用
            </Button>
            <Button 
              size={window.innerWidth <= 480 ? 'middle' : 'large'}
              style={{ 
                height: window.innerWidth <= 480 ? '50px' : '60px', 
                fontSize: window.innerWidth <= 480 ? '16px' : '18px', 
                padding: window.innerWidth <= 480 ? '0 30px' : '0 40px',
                borderRadius: '30px',
                borderColor: '#FF8A65',
                color: '#FF7043',
                minWidth: window.innerWidth <= 480 ? '220px' : 'auto'
              }}
              onClick={() => navigate('/login')}
            >
              已有账户？登录
            </Button>
          </motion.div>
        </motion.div>
      </section>

      {/* 联系我们模态框 */}
      {showContactModal && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(8px)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}
          onClick={() => setShowContactModal(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
              borderRadius: '24px',
              padding: window.innerWidth <= 480 ? '30px 20px' : '40px 30px',
              maxWidth: window.innerWidth <= 480 ? '90vw' : '500px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25), 0 10px 25px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.8)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* 关闭按钮 */}
            <button
              onClick={() => setShowContactModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                color: '#666',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
              }}
              onMouseEnter={(e) => {
                const target = e.target as HTMLElement;
                target.style.background = 'rgba(255, 255, 255, 1)';
                target.style.color = '#333';
                target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                const target = e.target as HTMLElement;
                target.style.background = 'rgba(255, 255, 255, 0.9)';
                target.style.color = '#666';
                target.style.transform = 'scale(1)';
              }}
            >
              ✕
            </button>

            {/* 标题 */}
            <div style={{
              textAlign: 'center',
              marginBottom: '25px'
            }}>
              <h2 style={{
                fontSize: window.innerWidth <= 480 ? '1.5rem' : '1.8rem',
                fontWeight: 'bold',
                color: '#333',
                marginBottom: '10px',
                lineHeight: '1.2'
              }}>
                📞 联系我们
              </h2>
              <p style={{
                color: '#666',
                fontSize: window.innerWidth <= 480 ? '0.9rem' : '1rem',
                margin: 0
              }}>
                扫描二维码，添加我们的微信咨询
              </p>
            </div>

            {/* 二维码图片 */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '25px'
            }}>
              <div style={{
                position: 'relative',
                borderRadius: '16px',
                padding: '12px',
                background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(248,249,255,0.9))',
                boxShadow: '0 8px 25px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.8)',
                border: '1px solid rgba(255,255,255,0.6)'
              }}>
                <img 
                  src="/pic_3.jpg" 
                  alt="联系我们二维码"
                  style={{
                    width: '100%',
                    maxWidth: window.innerWidth <= 480 ? '280px' : '350px',
                    height: 'auto',
                    borderRadius: '12px',
                    display: 'block'
                  }}
                />
                {/* 渐变边框效果 */}
                <div style={{
                  position: 'absolute',
                  top: '12px',
                  left: '12px',
                  right: '12px',
                  bottom: '12px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, rgba(255,182,193,0.2) 0%, rgba(221,160,221,0.2) 50%, transparent 70%)',
                  pointerEvents: 'none'
                }}></div>
              </div>
            </div>

            {/* 底部说明文字 */}
            <div style={{
              textAlign: 'center',
              fontSize: window.innerWidth <= 480 ? '0.85rem' : '0.9rem',
              color: '#888',
              lineHeight: '1.4'
            }}>
              <p style={{ margin: '0 0 8px 0' }}>
                💬 专业团队为您提供一对一咨询服务
              </p>
              <p style={{ margin: 0 }}>
                ⏰ 工作时间：9:00-21:00
              </p>
            </div>
          </motion.div>
        </div>
      )}

      {/* 自定义样式 */}
      <style>{`
        /* 平滑滚动 */
        * {
          scroll-behavior: smooth;
        }
        
        /* 针对移动端的优化 */
        @media (max-width: 768px) {
          section {
            scroll-snap-align: start;
          }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;